<div class="referencing-section">
    <div class="referencing-section__toggle">
        <aum-switch-toggle
            [checked]="addNumbering && !disabled"
            [disabled]="disabled"
            (toggle)="onAddNumberChange($event)"
        ></aum-switch-toggle>
        <span>{{ 'aumico_add_numbering_toggle' | i18next }}</span>
    </div>

    <div class="referencing-section__action-btn">
        <button
            [disabled]="disabled || !addNumbering"
            [class.disable]="disabled"
            (click)="onClick()"
            stopPropagation
            aum-icon-button
            icon="plus"
            color="basic"
        >
            {{ 'aumico_add_referencing_in_balance_and_income_btn' | i18next }}
        </button>
    </div>
</div>
